/** @jsx jsx */
import { jsx } from "@emotion/core"
import { IRecord } from "../../types/schema"
import { KeyValueList } from "../KeyValueList"
import { createHoverLoader } from "./createHoverLoader"

type IDepartment = IRecord<"departments", "name"> & { numberOfEmployees: number }

export const HoverDepartmentLoader = createHoverLoader<IDepartment>({
  model: "departments",
  attributes: ["name", { as: "numberOfEmployees", value: { count: { attr: "employees" } } }],
  Target({ record }) {
    return record.name
  },
  HoverContent({ record }) {
    return (
      <KeyValueList
        data={[
          { label: "Name", value: record.name },
          { label: "# of employees", value: record.numberOfEmployees },
        ]}
      />
    )
  },
})
